import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const COMPANY = {
  name: "B-Raw Snack Food Product",
  tagline: "Tasty & Crunchy!",
  founder: "Devender Yadav",
  email: "officialbraw@gmail.com",
  phone: "+917976854063",
  phone_display: "+91 79-76854063",
  fssai: "20825019000883",
  address:
    "Gali no 11, near Satyam Sofa, Dashmesh Nagar, Dasha Shah Nagar, Sirsa, Haryana 125055, India",
  maps_url:
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent(
      "Gali no 11, near Satyam Sofa, Dashmesh Nagar, Dasha Shah Nagar, Sirsa, Haryana 125055"
    ),
};

export const LOGO_URL = "/braw-logo.png";
